import { render, staticRenderFns } from "./batchDeal.vue?vue&type=template&id=4af3956a&scoped=true&"
import script from "./batchDeal.vue?vue&type=script&lang=js&"
export * from "./batchDeal.vue?vue&type=script&lang=js&"
import style0 from "./batchDeal.vue?vue&type=style&index=0&id=4af3956a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3956a",
  null
  
)

export default component.exports